import { Ticket, TicketStatus } from '../../../store/Ticket';
import { getUsersByRolesSubject } from '../../../store/User';
import { DetailPanelParams, FieldLabelMap } from '../../Compounds/DetailPanel/DetailPanel';
import { EditFieldType } from '../../Compounds/DetailPanel/LabelValueField';
import { EntityType } from '../../../store/Search';

export const FIELD_LABEL_MAP: FieldLabelMap = {
  status: 'Status',
  inquiryType: 'Inquiry Type',
  assignedTo: 'Assigned To',
  ticketType: 'Ticket Type',
  description: 'Description',
  proactive: 'Proactive',
  firstRun: 'First Run Disputed',
  lastRun: 'Last Run Resolved',
  receivedDate: 'Received Date',
  expectedResolutionDate: 'Expected Resolution Date',
  submittedToSourceDate: 'Submitted to Source Date',
  actualResolutionDate: 'Actual Resolution Date',
  sourceTrackingNumber: 'Source Tracking Number',
  resolutionType: 'Resolution Type',
  resolutionFromSource: 'Resolution From Source',
  supplier: 'Supplier',
  tsd: 'TSD',
  customerList: 'Customer List',
  apList: 'AP List'
};

export const ticketSections = (ticketData: Ticket, forDrawer: boolean = false): DetailPanelParams[] => [
  {
    data: ticketData,
    canEdit: [
      { field: 'description', type: EditFieldType.TEXTAREA, useDefaultWidth: forDrawer },
      {
        field: 'proactive',
        type: EditFieldType.SELECT,
        options: ['Yes', 'No'],
        default: 'No'
      },
      {
        field: 'status',
        type: EditFieldType.AUTOCOMPLETE,
        options: Object.values(TicketStatus)
      },
      {
        field: 'inquiryType',
        type: EditFieldType.AUTOCOMPLETE,
        options: [
          'Account Dropped Off',
          'Order Tracking Inquiry',
          'Account Billing Decreased',
          'Chargeback Question',
          'Billing Question',
          'Information Request',
          'Commission Percent',
          'SPIFF Missing',
          'Payment Question',
          'Reporting Question'
        ]
      },
      {
        field: 'assignedTo',
        type: EditFieldType.AUTOCOMPLETE,
        options: getUsersByRolesSubject().getValue()
      }
    ],
    fieldMap: FIELD_LABEL_MAP,
    order: ['status', 'inquiryType', 'assignedTo', 'ticketType', 'description', 'proactive']
  },
  {
    data: ticketData,
    canEdit: [
      { field: 'sourceTrackingNumber', type: EditFieldType.TEXT },
      { field: 'receivedDate', type: EditFieldType.DATE },
      { field: 'submittedToSourceDate', type: EditFieldType.DATE },
      { field: 'expectedResolutionDate', type: EditFieldType.DATE },
      { field: 'actualResolutionDate', type: EditFieldType.DATE },
      { field: 'firstRun', type: EditFieldType.DATE },
      { field: 'lastRun', type: EditFieldType.DATE },
      {
        field: 'resolutionType',
        type: EditFieldType.MULTI_SELECT,
        options: [
          null,
          'Disconnect',
          'Information Provided',
          'True-Up',
          'No Correction Necessary',
          'Account Number Change',
          "Monitoring - Comp Rec'd as Expected",
          'Customer Credit',
          'Compression',
          'Delayed Install',
          'Denied - Deal Not Properly Registered',
          'Denied - Outside of Submission Window'
        ]
      },
      { field: 'resolutionFromSource', type: EditFieldType.TEXTAREA }
    ],
    fieldMap: FIELD_LABEL_MAP,
    order: [
      'firstRun',
      'lastRun',
      'receivedDate',
      'expectedResolutionDate',
      'submittedToSourceDate',
      'actualResolutionDate',
      'sourceTrackingNumber',
      'resolutionType',
      'resolutionFromSource'
    ]
  },
  {
    data: ticketData,
    canEdit: [
      {
        field: 'supplier',
        type: EditFieldType.SEARCHBOX,
        mapType: EntityType.SUPPLIER
      },
      {
        field: 'tsd',
        type: EditFieldType.SEARCHBOX,
        mapType: EntityType.TSD
      }
    ],
    fieldMap: FIELD_LABEL_MAP,
    order: ['supplier', 'tsd', 'customerList', 'apList'],
    associationNameFields: {
      supplier: 'supplierName',
      tsd: 'tsdName'
    },
    links: [
      {
        field: 'customerList',
        link: '/customer/',
        external: true,
        externalLink: (id: string) => `${process.env.REACT_APP_SALESFORCE_INSTANCE_URL}/lightning/r/Account/${id}/view`
      },
      {
        field: 'apList',
        link: null,
        external: true,
        externalLink: (id: string) => `${process.env.REACT_APP_SALESFORCE_INSTANCE_URL}/lightning/r/Account/${id}/view`
      }
    ]
  }
];
